<template>
    <div
        class="app"
        :class="[$root.modalOpen && 'modal-open', slideView && 'slide-view']"
    >
        <Header />
        <SlideCanvas ref="canvas" />
        <transition
            name="view"
            mode="out-in"
            appear
            @before-leave="leaveView"
            @before-enter="enterView"
            @enter="$root.executeHeightChange(0.1)"
        >
            <router-view
                ref="view"
                :key="routerKey"
                class="view"
            />
        </transition>
    </div>
</template>

<script>
import Header from '@/components/app/Header';
import SlideCanvas from '@/components/app/SlideCanvas';

const transitionDuration = 1;

export default {
    name: 'App',
    components: {
        SlideCanvas,
        Header
    },
    data: () => ({
        routerKey: '',
        slideView: false
    }),
    watch: {
        $route(to)
        {
            this.setRouterKey(to);
        }
    },
    created()
    {
        this.setRouterKey(this.$route);
    },
    methods: {
        loadCanvasBackgrounds(backgrounds)
        {
            return this.$refs.canvas.setBackgroundImages(backgrounds);
        },
        animateTransition(config)
        {
            const {canvas, view} = this.$refs;
            const transitionDirection = view.lastTransitionDirection || 0;

            let duration = config.duration || transitionDuration;

            if (transitionDirection < 0)
            {
                duration *= 0.5;
                config.insetFromFull = false;
                config.insetFromNull = false;
                config.timeScale = 0.5;
                config.swoosh = false;
            }
            if (config.insetFromFull)
            {
                duration *= 0.75;
            }
            config.duration = duration;
            canvas.animateTransition(config);
        },
        setRouterKey(route)
        {
            if (route.params.module)
            {
                this.routerKey = route.params.module;
                return;
            }
            this.routerKey = route.name;
        },
        leaveView()
        {
            this.$root.prepareHeightChange();
            this.$refs.canvas.animateTransition({
                duration: 0.5,
                color: 'blue',
                inset: {},
                image: '',
                changeImageInstantly: true,
                swoosh: this.$route.name === 'home'
            });
        },
        enterView()
        {
            const {name} = this.$route;
            this.slideView = name === 'tutorial' || name === 'module';
        }
    }
};
</script>

<style lang="scss" src="./styles/styles.scss" />
